const state = {
}

const getters = {
}

const actions = {

  // eslint-disable-next-line
  notify ({ commit }, { message, error, context }) {
    let config = {
      position: 'bottom-right',
      customClass: 'notification',
      duration: 10000
    }

    if (message) {

      config.message = message
      context.$notify(config)

    } else if (error.hasOwnProperty('response')) {

      // 驗證逾期
      if (error.response.data.result === -97) {
        let button = `<a href="javascript:void(0)" onclick="location.reload()">重新整理</a>`

        config.dangerouslyUseHTMLString = true
        config.message = error.response.data.msg + button
        context.$notify(config)
        return
      }

      config.message = error.response.data.msg
      context.$notify(config)

    } else {
      console.error(error)
      config.message = '系統出錯了'
      context.$notify(config)
    }
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
